<template>
    <!-- Add new product modal -->
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card" id="modalWindow">
        <header class="modal-card-head">
          <slot name="header"></slot>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          <slot name="body"></slot>
        </section>
        <footer class="modal-card-foot">
          <slot name="footer"></slot>
        </footer>
      </div>

      <loading :active.sync="loading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";

export default {
  name: "modal-window",
  components: { Loading },
  props: {
    loading: Boolean
  },
  methods: {
    mouseClickListener(evt) {
      if (document.getElementById("modalWindow").contains(evt.target)) {
        // Clicked in box
        console.log("click in modal");
      } else if (evt.target.className !== "download-js-link"){
        // Clicked outside the box
        var areYouShure = confirm(
          "Are you sure that you want to close window?"
        );
        if (areYouShure) {
          this.$emit("close");
        }
      }
    },
    keyDownListener(evt) {
      if (evt.keyCode === 27) {
        var areYouShure = confirm(
          "Are you sure that you want to close window?"
        );
        if (areYouShure) {
          this.$emit("close");
        }
      }
    }
  },
  created() {
    document.addEventListener("click", this.mouseClickListener);
    document.addEventListener("keydown", this.keyDownListener);
  },
  destroyed() {
    document.removeEventListener("click", this.mouseClickListener);
    document.removeEventListener("keydown", this.keyDownListener);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ModalWindow.Vue